import { baseApi, getErrorMessage } from '@/shared/api';
import { mapRole } from '../libs/mapRole';
import type { CreateRoleParams, Role } from '../model/types';
import type { RoleDTO } from './types';

export const getRoles = async (): Promise<Role[]> => {
  const { data, error } = await baseApi.functions.invoke<{
    roles: RoleDTO[];
  }>('roles', {
    method: 'GET',
  });

  if (!data) {
    throw new Error(getErrorMessage(error));
  }

  return (data.roles ?? []).map(mapRole);
};

export const createRole = async (params: CreateRoleParams): Promise<Role> => {
  const { data, error } = await baseApi.functions.invoke<RoleDTO>('roles', {
    method: 'POST',
    body: params,
  });

  if (!data) {
    throw new Error(getErrorMessage(error));
  }

  return mapRole(data);
};

export const updateRole = async (
  id: string,
  params: CreateRoleParams,
): Promise<Role> => {
  const { data, error } = await baseApi.functions.invoke<RoleDTO>(`roles/${id}`, {
    method: 'PUT',
    body: params,
  });

  if (!data) {
    throw new Error(getErrorMessage(error));
  }

  return mapRole(data);
};

export const deleteRole = async (id: string): Promise<void> => {
  const { error } = await baseApi.functions.invoke<void>(`roles/${id}`, {
    method: 'DELETE',
  });

  if (error) {
    throw new Error(getErrorMessage(error));
  }
};
